import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { useEffect, useState } from 'react';
import { useCreateEvent } from '../../events/hooks/useCreateEvent';
import { EventType } from '../../events/types/EventType';
import { OverviewChart } from './OverviewChart';
interface Props {
  numberOfMarkers: number;
  normalMarkers: number;
  warningMarkers: number;
  criticalMarkers: number;
  outdatedMarkers: number;
}

export const OverviewCard = ({
  numberOfMarkers,
  normalMarkers,
  warningMarkers,
  criticalMarkers,
  outdatedMarkers,
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [progressBar, setProgressBar] = useState(0);
  const { sendEvent } = useCreateEvent()

  const onShowMoreClick = async () => {
    setIsExpanded(!isExpanded)
    await sendEvent({
      event: EventType.CLICK,
      sub_category: "ocr_interaction",
      event_metadata: { action: "show_more/less_on_overview_card" }
    })
  }

  useEffect(() => {
    const recentMarkers = normalMarkers + warningMarkers + criticalMarkers;
    const totalMarkers = recentMarkers + outdatedMarkers;
    const progress = (recentMarkers / totalMarkers) * 100;
    setProgressBar(progress);
  }, [normalMarkers, warningMarkers, criticalMarkers, outdatedMarkers]);
  return (
    <Card className='rounded-[15px] border border-solid gap-6 '>
      <CardHeader className='flex'>
        <div className='w-full flex items-center justify-between text-[12px]'>
          <div className='flex items-center justify-start gap-2'>
            <p className='font-bold'> Panoramica dei marker</p>
            <p>|</p>
            <p> {numberOfMarkers} totali</p>
          </div>
          <div
            className='font-bold text-primary cursor-pointer'
            onClick={onShowMoreClick}
          >
            Mostra {isExpanded ? 'meno' : 'di più'}
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {isExpanded ? (
          <OverviewChart
            normalMarkers={normalMarkers}
            warningMarkers={warningMarkers}
            criticalMarkers={criticalMarkers}
            outdatedMarkers={outdatedMarkers}
          />
        ) : (
          <Progress value={progressBar} />
        )}
      </CardContent>
    </Card>
  );
};
